module.exports = __webpack_public_path__ + "static/media/cmm.3da63282.svg";